export enum TimeBankTransactionType {
    InitialBalance = 0,
    PutInto = 1,
    TakenFrom = 2,
    ManualAdjustment = 3,
}

export enum TimeBankTransactionSourceType {
    Migration = 0,
    Shift = 1,
    Absence = 2,
    ManualAdjustment = 3,
}

export interface TimeBankBalance {
    employeeId: number;
    balance: number;
}

export interface TimeBankTransaction {
    id: number;
    employeeId: number;
    date: string;
    hours: number;
    type: TimeBankTransactionType;
    sourceType: TimeBankTransactionSourceType;
    sourceId?: number;
    comment?: string;
    createdByEmployeeId?: number;
    created: string;
    updated: string;
    canDelete: boolean;
}

export interface TimeBankReportEmployee {
    employeeId: number;
    balance: number;
    putInto?: number;
    takenFrom?: number;
    transactions: TimeBankTransaction[];
}

export interface TimeBankManualTransactionRequest {
    date: string;
    hours: number;
    comment?: string;
}
